import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import KpiandRR from "./BizLeaderMobileModules/KpiandRR/KpiandRR";
import Recent from "./BizLeaderMobileModules/Recent/Recent";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../assets/styles/tokens";
import Brands from "./BizLeaderMobileModules/Brands/Brands";
import Budget from "./BizLeaderMobileModules/Budget/Budget";
import { AppBar } from "@mui/material";

export default function BizLeaderMobileDashboardTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Box sx={{ height: "93vh", overflowY: "auto" }}>
        <AppBar
          position="sticky"
          sx={{
            bgcolor: "background.paper",
           // borderBottom: `1px solid ${colors.GrayLightMode[200].$value}`,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-scrollButtons": {
                color: colors.GrayDarkMode[700].$value,
              },
            }}
            TabIndicatorProps={{
              sx: {
                backgroundColor: colors.Brand[600].$value,
                height: spacing.Spacing.xxs.$value,
              },
            }}
          >
            {[
              "KPI’s & RR",
              "Recent",
              "Brands",
              "Budget",
              "Keywords",
              "Conversions",
              "Performance",
            ].map((label) => (
              <Tab
                key={label}
                label={label}
                disableRipple
                sx={{
                  color: colors.GrayDarkMode[700].$value,
                  textTransform: "none",
                  fontFamily: typography["Display 2xl"].Regular.$value,
                  fontWeight: typography.Font_weight.Medium.$value,
                  "&.Mui-selected": {
                    color: "#181D27",
                  },
                  "&:hover": { backgroundColor: "transparent" },
                  "&:first-of-type": {
                    marginLeft: spacing.Spacing["6xl"].$value,
                  },
                }}
              />
            ))}
          </Tabs>
        </AppBar>

        {/* 🔽 TAB CONTENTS */}
        <TabPanel value={value} index={0}>
          <KpiandRR />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Recent />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Brands />
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Budget />
        </TabPanel>

        <TabPanel value={value} index={4}>
          Keywords Content
        </TabPanel>

        <TabPanel value={value} index={5}>
          Conversions Content
        </TabPanel>

        <TabPanel value={value} index={6}>
          Performance Content
        </TabPanel>
      </Box>
    </>
  );
}
